import React from 'react';
import styles from '../layout/AdminLayout.module.css';

const StudyManagementComponent: React.FC = () => {
  return (
    <div className={styles.pageContainer}>
      <div>
        <h1 className={styles.pageTitle}>스터디 관리</h1>
      </div>
      
      <div className={styles.pageContent}>
        <p>스터디 관리 기능을 구현해주세요.</p>
      </div>
    </div>
  );
};

export default StudyManagementComponent;
